<template>
	<div :class="['questionnaire', 'analysis']">
		<MultiLineGraph v-if="isScored" 
			name="All Question Score chart" 
			class="multi-line-graph"
			:max="getMaxScoreMultiGraph"
			:dates="getMultiGraphDates"
			:data="getMultiGraphData">
		</MultiLineGraph>
		<template v-for="(question, i) in questionnaireContent.question">
			<div v-if="isUnitType(i) && isValidProgressReportingQuestion(i)" class="questions card" :key="question.id + i">
				<span class="text">
					<span v-if="(isScored || (!isScored && !fillTableQuestions.includes(question.type))) && progressReportingQuestions.includes(question.type)">{{ getScreenshotText(question.id) }}</span>
					<br><br>
					{{ i + 1 }}. {{ question.title }} <span class="question-desc">({{ question.question }})</span>
				</span>
				<div v-if="getResponses(question.id) == null">
					Patient did not answer
				</div>
				<div v-else-if="progressReportingQuestions.includes(question.type) && question.hasOwnProperty('progress_reporting') && question.progress_reporting"
					:is="responseType(question)"
					:question="question"
					v-bind:response="getResponses(question.id)"
					:oresponse="getOResponse(question.id)"
					v-bind:questionnaire="orderedQuestionnaires"
					v-bind:patient="patient"
					@addFlagObj="addNewFlag"
					:isScored="isScored"
					:qNum="i+1"
					:is-survey="false"
					:cnstFrmCnntd="checkIfConsFrmQuestConnected(question)">
				</div>
				<div v-else-if="!progressReportingQuestions.includes(question.type)" class="not-enabled">
					<span>Not applicable</span>
				</div>
				<div v-else class="not-enabled">
					<span>Progress Reporting not enabled</span>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import CardAnalysis from '../../component/analysis'
import Responses from './response/components'
import responseMap from './response/map'

import formatDateTime from '@/module/util/format-date-time'
import isEmptyObj from '@/module/util/empty-object'

import MultiLineGraph from './MultiLineGraph.vue'
import formatDate from '@/module/util/format-date'
import { arrayFindIndex } from 'element-ui/src/utils/util'

export default {
	name: 'questionnaire-card-analysis',
	extends: CardAnalysis,

	props: {
		questionnaire: {
			type: Array,
			required: true
		},
		id: {
			type: String,
			required: true
		},
		patient: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			progressReportingQuestions: [
				'slider', 
				'star', 
				'radio', 
				'scroller', 
				'unit', 
				'select', 
				'large_image_select', 
				'small_image_select',
				'box_select',
				'long_text_bubble',
				'binary'
			],
			fillTableQuestions: [
				'binary',
				'box_select',
				'small_image_select',
				'large_image_select',
				'long_text_bubble',
				'scroller',
				'select'
			],
			limitSelectQuestions: [
				'box_select',
				'small_image_select',
				'large_image_select',
				'long_text_bubble',
				'select'
			]
		}
	},

	methods: {
		formatDate,
		limitSelect(question) {
			if (question.hasOwnProperty('limit_select') && question.limit_select && 
				question.hasOwnProperty('validations') && question.validations.filter(v => v.type === 'max_selection').length)
				return question.validations.filter(v => v.type === 'max_selection')[0].value
			return 0
		},
		isUnitType(i) {
			let curQues = this.questionnaireContent.question[i]
			if (curQues.type === 'unit') {
				if (curQues.options.length === 1)
					return true
				return false
			}
			return true
		},
		isValidProgressReportingQuestion(i) {
			let curQues = this.questionnaireContent.question[i]
			return (this.getResponses(curQues.id) == null || (this.progressReportingQuestions.includes(curQues.type) && curQues.hasOwnProperty('progress_reporting') && curQues.progress_reporting))
		},
		addNewFlag(flag) {
			this.questionnaire.forEach(q => {
				if (q.id === flag.problem_id) {
					if (!q.hasOwnProperty('problem'))
						q.problem = []
					q.problem.push(flag)
				}
			})
		},
		getDateString(timestamp) {
			let date = new Date(timestamp).toDateString()
			return date.split(' ')[1] + ' ' + date.split(' ')[2]
		},
		getDateTimeString(timestamp) {
			let strTime = this.formatDateTime(new Date(timestamp))
			strTime = strTime.replace(' at', ',')
			return strTime
		},
		isResolved(flagObj) {
			if (flagObj.hasOwnProperty('resolved_by') || flagObj.hasOwnProperty('resolved_time') || flagObj.hasOwnProperty('resolved_name'))
				return true
			return false
		},
		/**
		 * @returns Array of objects i.e flags from different questionnaires given the question id
		 */
		getFlags(id) {
			let problems = []
			this.questionnaire.filter(question => question.hasOwnProperty('problem') && question.problem.length)
			.forEach(question => {
				question.problem.filter(problem => problem.question_id === id)
				.forEach(p => problems.push(p))
			})
			return problems
		},
		responseType(question) {
			return responseMap[question.type]
		},
		getResponses(id) {
			return this.orderedQuestionnaires
			.map((questionnaire) => {
				let response = questionnaire.question.find((response) => (response != null && response.id === id)),
					question = this.questionnaireContent.question.find((question) => question.id === id),
					newResponse
				if (response)
					newResponse = response.answer || response.value
				if(response && (response.image_url || response.image_description))
					newResponse = response
				if(newResponse && this.checkNullAnswer(question,newResponse))
					return null

				
				if(Array.isArray(newResponse) && newResponse.length > 0 && (newResponse.some((resObj) => resObj && resObj.value) || (newResponse[0] && newResponse[0].answer)))
					newResponse = this.getOldAnswer(question, newResponse)

				
				return newResponse
			})
			// Filter skipped responses for questions
			// .filter((r) => (r != null))
		},
		getDateRange(id) {
			let data = []
			this.getOResponse(id).forEach((res, index) => {
				if (res && res.length) {
					data.push(this.formatDate(this.orderedQuestionnaires[index].completed))
				}
			})
			let len = data.length
			return '(' + data[len-1] + ' - ' + data[0] + ')'
		},
		isAnswered(id) {
			let found = false
			this.getOResponse(id).forEach(res => {
				if (res) found = true
			})
			return found
		},
		getScreenshotText(id) {
			return this.patient.name + 
					(this.questionnaireContent.hasOwnProperty('branch') && this.questionnaireContent.branch ? (' - ' + this.questionnaireContent.title) : '') + 
					' ' + 
					(this.isAnswered(id) ? this.getDateRange(id) : '')
		},
		getOResponse(id) {
			return this.orderedQuestionnaires.map((questionnaire) => {
				let response = questionnaire.question.find((response) => (response != null && response.id === id)),
					question = this.questionnaireContent.question.find((question) => question.id === id),
					newResponse
				if(response && (response.image_url || response.image_description))
					newResponse = response
				if (response)
					newResponse = response.answer || response.value || response.image_url
				return newResponse
			})
		},
		getResponse(questionContent, questionnaire) {
			return questionnaire.question.find((questionResponse) => {
				return questionResponse != null && questionResponse.id == questionContent.id
			})
		},
		checkNullAnswer(question, answer) {
			if(question.type === 'text' && answer[0] && answer[0].answer === null)
				return true
			if(question.type === 'unit' && answer[0] && isEmptyObj(answer[0]))
				return true
			return false
		},
		getOldAnswer (question, answer) {
			let oldAnswer = answer
			//console.log(answer)
			if(question.type === 'select') {
				oldAnswer = answer.map((ansObj) => ansObj.value)
			}

			else if (['box_select', 'large_image_select', 'small_image_select'].includes(question.type)) {
				oldAnswer = answer.reduce((accAns, ansObj) => {
					const selectArr = Object.entries(question.select).find(([key, value]) => ansObj.value === value)
					if(selectArr)
						accAns[selectArr[0]] = selectArr[1]
					return accAns
				}, {})
				if(question.type === 'box_select')
					oldAnswer.other  = answer.
						filter((ansObj) => !Object.values(question.select).some((value) => ansObj.value === value))
						.map(({value}) => value)

			}

			else if(['scroller', 'slider'].includes(question.type)) {
				oldAnswer = Array.isArray(answer) && (answer.length === 1) ? { [answer[0].value] : question.label[answer[0].value] } : null
			}

			else if(question.type === 'star') {
				oldAnswer = { [answer[0].value]: question.label[answer[0].value] }
			}

			else if(question.type === 'radio') {
				oldAnswer =  parseInt(answer[0].value) + 1
			}
			
			else if(question.type === 'human_map') {
				oldAnswer = answer.map(({value}) => value)
			}

			else if(question.type === 'binary')
				oldAnswer = Array.isArray(answer) && (answer.length === 1) ? { 0 : answer[0].value } : null

			else if(question.type === 'text' && answer.length === 1 && answer[0].answer)
				oldAnswer = { 0 : answer[0].answer }
			
			else if(question.type === 'image_upload')
				oldAnswer = {
					image_url: answer[0].value,
					image_description: answer[0].answer
				}
			else if(question.type === 'sign_document') {
				oldAnswer = answer
				oldAnswer[0].image_url = oldAnswer[0].value
			}
				
			return oldAnswer
		},
		getInsideDoubleCurly(str) {
			return str.split('{{').filter(val => val.includes('}}')).map(val => val.substring(0, val.indexOf('}}')).trim())
		},
		checkIfConsFrmQuestConnected(quest) {
			if(quest.type === 'multi_question') {
				let subQuestIds = quest.questions.map(subQuest => subQuest.id)
				return subQuestIds.some((subId) => this.consFrmCnntdQuestIds.includes(subId))
			} else return this.consFrmCnntdQuestIds.includes(quest.id)
		}
	},

	computed: {
		...mapGetters(["getUserType"]),
		...mapGetters('provider', [
			'getPatientEvents'
		]),
		getMaxScoreMultiGraph() {
			let totalMaxScore = 0
			this.questionnaireContent.question.forEach(ques => {
				let max = 0
				let scores = []

				if (ques.type === 'long_text_bubble') {
					ques.options.forEach(op => scores.push(op.score))
				} else if (ques.hasOwnProperty('score')) {
					scores = Object.values(ques.score.default)
				}
				scores.sort(function(a, b){return a-b}).reverse()


				if (this.limitSelectQuestions.includes(ques.type) && scores.length) {
					const limit = this.limitSelect(ques)
					if (limit) {
						for(let i = 0; i < limit; i++)
							max += scores[i]
					} else max = scores.reduce(function (acc, s) { return acc + s; }, 0)
				} else max = scores[0]

				if (max) totalMaxScore += max
			})
			return totalMaxScore
		},
		getMultiGraphDates() {
			return this.orderedQuestionnaires.map(q => this.formatDate(q.completed)).reverse()
		},
		getMultiGraphData() {
				let dataset = []
				let finalData = []
				let colors = ['skyblue', '#ffcc00', 'orange', 'crimson', 'lightgreen', 'pink', '#66ffff', '#ffffcc', '#ffccff', '#009900', '#cc00ff', '#815B5B', '#FFABE1', '#937DC2', '#00cc99', '#ff5050', '#993300', '#0099cc', '#ccccff', '#ADDDD0']

				this.orderedQuestionnaires.forEach((q) => {
					// reset scores values
					let scores = {}
					this.questionnaireContent.question.forEach(q => scores[q.id] = 0)

					q.question.forEach((qq, index) => {
						// if already calculated then return
						if (scores[qq.id] !== 0) return
						// else calculate
						qq.answer.forEach(ans => {
							// searching the answer in question content's options
							this.questionnaireContent.question.forEach((qContent) => {
								if (qq.id === qContent.id) {
									qContent.options.forEach((option, idx) => {
										// if found then use the same idx for the score as well
										if (ans !== null && option.value === ans.value && option.id === ans.id && (qContent.score || option.score) && this.isScored) {
											if(qContent.type === 'long_text_bubble')
												scores[qContent.id] = scores[qContent.id] + option.score
											else scores[qContent.id] = scores[qContent.id] + qContent.score.default[idx]
										}
									})
								}
							})
						})
					})
					let scoresArray = []
					Object.keys(scores).forEach(s => scoresArray.push(scores[s]))
					dataset.push(scoresArray)
				})
				dataset.reverse()

				// Main question score chart
				let mainData = []
				dataset.forEach(set => {
					let score = 0
					set.filter(s => s || s === 0)
						.forEach((s, i) => {
							let curQ = this.questionnaireContent.question[i]
							if (curQ && curQ.hasOwnProperty('progress_reporting') && curQ.progress_reporting) {
								score = score + s
							}
						})
					mainData.push(score)
				})

				let mainObj = {
					label: 'All questions',
					backgroundColor: '#333333',
					borderColor: '#333333',
					data: mainData,
					fill: false,
					borderWidth: 7,
					line: true
				}
				finalData.push(mainObj)

				// All question separate score chart
				// let colorIndex = 0
				// this.questionnaireContent.question.forEach((q, index) => {
				// 	if (q.hasOwnProperty('progress_reporting') && q.progress_reporting) {
				// 		if (q.type != 'unit' || (q.type === 'unit' && q.options.length === 1 && !this.isScored)) {
				// 			let data = []
				// 			dataset.forEach(set => {
				// 				data.push(set[index])
				// 			})
				// 			if (!data.includes(NaN)) {
				// 				let reqObj = {
				// 					label: q.title || ('Q' + (index + 1)),
				// 					backgroundColor: colors[colorIndex],
				// 					borderColor: colors[colorIndex],
				// 					data: data,
				// 					fill: false
				// 				}
				// 				colorIndex += 1
				// 				finalData.push(reqObj)
				// 			}
				// 		}
				// 	}
				// })
				return finalData
		},
		isScored() {
			if (this.questionnaireContent.is_scored)
				return true
			return false
		},
		patientEvents() {
			return this.getPatientEvents(this.patient.id)
		},
		/**
		 * @func questionnaireContent
		 * @desc The underlying content object for this questionnaire.
		 */
		questionnaireContent() {
			let content = { ...this.getContent('questionnaire', this.id)}
			content.question = content.question.filter((question) => !question.ref_question)
			content.question = [ ...content.question.flatMap((question, index) => {
				if(question.type === 'section_separator')
					return []
				if(question.type === 'questionnaire') {
					return []
				}
				else if(Array.isArray(question.options) && question.options.length > 0 && question.options.some(({questionnaire}) => questionnaire)) {
					return [question]
				}
				else
					return [question]

			})]

			return content
		},

		/**
		 * @func orderedQuestionnaires
		 * @desc Questionnaires ordered in reverse chronological order
		 */
		orderedQuestionnaires() {
			return this.questionnaire.slice()
				.filter((q) => q.completed)
				.map((q) => {
					q.question = q.question.flatMap((questionObj) => {
						return [questionObj]
					})
					return q
				})
				.sort((a, b) => (b.completed - a.completed))
		},
		consFrmCnntdQuestIds() {
			let consFrmCnntdQuests = []

			let signedQuest = this.questionnaireContent && 
								this.questionnaireContent.question && 
								!!this.questionnaireContent.question.length && 
								this.questionnaireContent.question.find(quest => quest.type === 'sign_document')

			if(signedQuest && signedQuest.attachments && !!signedQuest.attachments.length) {
				let signedQuestTxt = signedQuest.attachments[0].text
				consFrmCnntdQuests = this.getInsideDoubleCurly(signedQuestTxt)
			}

			return consFrmCnntdQuests
		}
	},

	components: {
		...Responses,
		formatDateTime,
		MultiLineGraph
	}
}
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";
@import "../../component/table/style/analysis.scss";

.not-enabled {
	padding: 15px 20px;
	span {
		font-style: normal;
		font-weight: 500;
		font-size: 12px;
		line-height: 20px;
		color: #333333;
	}
}

.multi-line-graph {
	height: 500px;
	padding: 20px;
	margin-bottom: 15px;
	background-color: #ffffff;
}

.questions.card {
	display: flex;
	flex-direction: column;
	padding: 0;
	margin-top: 0;
	.text {
		margin: 12px 14px;
		font-size: 13px;
		font-weight: 700;
		color: $black-color;
		.question-desc {
			color: $dark-grey;
			font-size: 12px;
			font-weight: normal;
			margin-left: 8px;
		}
	}
	.title {
		font-size: 12px;
		font-weight: 500;
		color: #7f7f7f;
	}
}
.flag {
	margin-left: 7px;
}
.flag-image {
	width: 8px;
    height: 10px;
}
.flag-container-image {
    display: inline-block;
    width: 18px;
    height: 18px;
    padding: 0px 0 2px 5px;
    border-radius: 50%;
}
.flag-unresolved {
	background: #FFEBEB;
	border: 1px solid #DA4E4E;
	border-radius: 10px;
	width: 65px;
	height: 20px;
	font-weight: normal;
	font-size: 12px;
	line-height: 15px;
	color: #333333;
	margin-bottom: 5px;
}
.flag-resolved {
	background: #E7FFEA;
	border: 1px solid #44B358;
	border-radius: 10px;
	width: 65px;
	height: 20px;
	font-weight: normal;
	font-size: 12px;
	line-height: 15px;
	color: #333333;
	margin-bottom: 5px;
}
.body {
	width: 100%;
	padding-top: 7px;
	padding-bottom: 7px;
}
.added-by {
	display: block;
	margin-top: 4px;
	font-size: 12px;
	font-weight: normal;
	line-height: 16px;
	color: #828282;
}
.comment {
	padding-left: 10px;
	font-weight: 600;
	font-size: 14px;
	line-height: 18px;
	color: #333333;
}
</style>
